import SvgImage from '@/components/Module/SvgImage';
import { StyledSVGButton } from '@/styles/GlobalStyles';
import { Tooltip } from '@mui/material';
import styled from '@emotion/styled';

import { Container, StyledIconBackGround } from './styles';
import { getFileType } from '@/components/Record/SubjectContent/AttachmentFile/FileContent/FileIcon';
import { Recording } from '@/types/api';
import { useGetAudioLink } from '@/hooks/apiHooks';
import { t } from 'i18next';

const DarkTooltip = styled(({ className, ...props }: any) => (
  <Tooltip {...props} classes={{ popper: className }} />
))({
  '& .MuiTooltip-tooltip': {
    backgroundColor: 'rgba(0, 0, 0, 0.87)',
    color: 'white',
    border: 'none',
    whiteSpace: 'nowrap',
    maxWidth: 'none',
  },
  '& .MuiTooltip-arrow': {
    color: 'rgba(0, 0, 0, 0.87)',
  },
});

type P = {
  data: Recording;
  handleDelete: () => void;
};

const AttachmentButton = ({ data, handleDelete }: P) => {
  const title = data.name;
  const isAudio = getFileType(title) === 'audio';
  const { data: downloadLink } = useGetAudioLink(data.uuid);

  return (
    <Container>
      {isAudio ? (
        <StyledIconBackGround>
          {<SvgImage name={'audio_wave'} />}
        </StyledIconBackGround>
      ) : (
        <SvgImage name={'video'} />
      )}
      <div
        style={{
          flexGrow: 1,
          marginLeft: '8px',
          fontSize: '12px',
          fontWeight: '400',
          lineHeight: '18px',
        }}
      >
        {title}
      </div>
      {data.duration !== '00:00' && (
        <div
          style={{
            fontSize: '12px',
            fontWeight: '400',
            lineHeight: '18px',
            color: 'var(--dk-text-secondary, #888D96)',
            marginRight: '16px',
          }}
        >
          {data.duration}
        </div>
      )}
      <div style={{ display: 'flex', gap: '16px', marginRight: '4px' }}>
        {downloadLink && (
          <DarkTooltip
            title={t('보안상 다운로드 기능은 현재 비활성화 되어 있습니다.')}
          >
            <StyledSVGButton
              onClick={undefined}
              style={{
                opacity: 0.5,
                cursor: 'not-allowed',
              }}
            >
              <SvgImage name={'download'} />
            </StyledSVGButton>
          </DarkTooltip>
        )}
        <StyledSVGButton onClick={handleDelete}>
          <SvgImage name={'x'} />
        </StyledSVGButton>
      </div>
    </Container>
  );
};

export default AttachmentButton;
